export enum CurrencySymbolEnum {
    Euro = "€",
    Pound = "£",
    SwissFranc = "CHF",
}
